/**
 * Downloads a file from a given URL and saves it with a specified filename
 * 
 * @param {string} url - The URL of the file to download
 * @param {string} filename - The name to save the file as
 */
function downloadFile(url, filename) {
  fetch(url)
      .then(response => {
          // Sstatus code in the range 200-299
          if (!response.ok) {
              throw new Error("Network response was not ok");
          }
          return response.blob();
      })
      .then(blob => {
          // Create an object URL
          const objectUrl = window.URL.createObjectURL(blob);
          
          // Create an anchor
          const anchorElement = document.createElement('a');
          anchorElement.style.display = 'none'; // Hide the element
          anchorElement.href = objectUrl; // Set its href attribute
          anchorElement.download = filename; // Set the download attribute
          
          // Attach the anchor element
          document.body.appendChild(anchorElement);
          
          // Simulate click
          anchorElement.click();
          
          // Revoke the object URL to free up resources
          window.URL.revokeObjectURL(objectUrl);
          
          // Remove the anchor element
          document.body.removeChild(anchorElement);
      })
      .catch(error => {
          alert(`An error occurred while downloading the file: ${error}`);
      });
}

export default downloadFile;
